var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.folderMarkerList),function(item){return _c('div',{key:'folderMarker'+item.labelName},[_c('folder-marker',{attrs:{"folderMarkerSize":_vm.folderMarkerSize,"folderMarkerInfo":item},on:{"clickFolderMarker":_vm.clickFolderMarker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }